import React from "react";
import {
  AppBar,
  Box,
  Button,
  Card,
  Container,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";

import {
  Person as UserIcon,
  CalendarMonth as CalendarIcon,
  HelpOutline as HelpCircleIcon,
  MoneyOutlined as DonationIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

function HomeScreen({ setActiveScreen }) {
  const navigate = useNavigate();

  return (
    <>
      {/* Header */}

      {/* Main Content */}
      <Container sx={{ py: 4 }}>
        <Card sx={{ mb: 4, p: 2 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              p: 2,
            }}
          >
            <Box
              sx={{
                height: 80,
                width: 80,
                borderRadius: "50%",
                bgcolor: "secondary.main",
                mb: 2,
              }}
            />
            <Typography variant="h4" fontWeight="bold" color="text.primary">
              Durga Temple of Virginia
            </Typography>
            <Typography variant="subtitle1" color="text.secondary">
              Welcome to the Temple Services
            </Typography>
          </Box>
        </Card>

        <Grid container spacing={3}>
          <Grid item xs={6}>
            <Button
              onClick={() => {
                navigate("/posdonation");
              }}
              fullWidth
              sx={{
                bgcolor: "#b71c1c",
                color: "white",
                height: 140,
                borderRadius: 3,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                transition: "transform 0.2s",
                "&:hover": {
                  bgcolor: "#b71c1c",
                  transform: "scale(1.03)",
                },
              }}
            >
              <DonationIcon sx={{ fontSize: 40 }} />
              <Typography variant="h6" sx={{ mt: 1 }}>
                Donations
              </Typography>
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              fullWidth
              sx={{
                bgcolor: "#ff8f00",
                color: "white",
                height: 140,
                borderRadius: 3,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                transition: "transform 0.2s",
                "&:hover": {
                  bgcolor: "#ff8f00",
                  transform: "scale(1.03)",
                },
              }}
            >
              <CalendarIcon sx={{ fontSize: 40 }} />
              <Typography variant="h6" sx={{ mt: 1 }}>
                Temple Services
              </Typography>
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              fullWidth
              sx={{
                bgcolor: "#6a1b9a",
                color: "white",
                height: 140,
                borderRadius: 3,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                transition: "transform 0.2s",
                "&:hover": {
                  bgcolor: "#6a1b9a",
                  transform: "scale(1.03)",
                },
              }}
            >
              <UserIcon sx={{ fontSize: 40 }} />
              <Typography variant="h6" sx={{ mt: 1 }}>
                Add Devotee
              </Typography>
            </Button>
          </Grid>
        </Grid>
      </Container>

      {/* Footer */}
    </>
  );
}

export default HomeScreen;
